import webSocketService from "@/services/web-socket-service";

var WebSocketAuthenticationHandler = (function () {
    var initialize = function ({ xAuthToken }) {
        return webSocketService.createConnectionToBackend(xAuthToken);
    }

    var terminate = function () {
       return webSocketService.closeConnectionToBackend();
    }

    return {
        initialize: initialize,
        terminate: terminate
    }
}());

export default WebSocketAuthenticationHandler;
